var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogojasne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "8bdf6055e3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 111.140625 90 L 245.390625 90 L 245.390625 284.9375 L 111.140625 284.9375 Z M 111.140625 90 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "07fbc7def8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 196 171 L 197.625 171 L 197.625 204 L 196 204 Z M 196 171 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bdb80ce35e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.375 171 L 161 171 L 161 204 L 159.375 204 Z M 159.375 171 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4cbcecfb27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 162 168.503906 L 194 168.503906 L 194 170 L 162 170 Z M 162 168.503906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac2e9952ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 162 205 L 194 205 L 194 206.753906 L 162 206.753906 Z M 162 205 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "25be7620e3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 193 168.503906 L 197.625 168.503906 L 197.625 172 L 193 172 Z M 193 168.503906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3b0dd8dc93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.375 168.503906 L 163 168.503906 L 163 172 L 159.375 172 Z M 159.375 168.503906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e12f2f09ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 193 203 L 197.625 203 L 197.625 206.753906 L 193 206.753906 Z M 193 203 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a4286495a8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.375 203 L 163 203 L 163 206.753906 L 159.375 206.753906 Z M 159.375 203 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6d5a896695"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 196 189 L 197.121094 189 L 197.121094 205 L 196 205 Z M 196 189 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3bfa954f9e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 178.371094 189 L 179 189 L 179 205 L 178.371094 205 Z M 178.371094 189 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c1dab75197"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 180 187.5 L 196 187.5 L 196 189 L 180 189 Z M 180 187.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e70e853cd9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 180 205 L 196 205 L 196 206.25 L 180 206.25 Z M 180 205 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a136f88b50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 195 187.5 L 197.121094 187.5 L 197.121094 190 L 195 190 Z M 195 187.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a2f3113202"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 178.371094 187.5 L 181 187.5 L 181 190 L 178.371094 190 Z M 178.371094 187.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0e3fdcf389"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 195 204 L 197.121094 204 L 197.121094 206.25 L 195 206.25 Z M 195 204 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a7c87a320d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 178.371094 204 L 181 204 L 181 206.25 L 178.371094 206.25 Z M 178.371094 204 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb74aa9016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 177 189 L 178.125 189 L 178.125 205 L 177 205 Z M 177 189 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "03bc69042d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.375 189 L 160 189 L 160 205 L 159.375 205 Z M 159.375 189 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b716349814"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 161 187.5 L 177 187.5 L 177 189 L 161 189 Z M 161 187.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f3d63ee0d8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 161 205 L 177 205 L 177 206.25 L 161 206.25 Z M 161 205 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 6172637353
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 176 187.5 L 178.125 187.5 L 178.125 190 L 176 190 Z M 176 187.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e172286f0a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.375 187.5 L 162 187.5 L 162 190 L 159.375 190 Z M 159.375 187.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "56b4a0a241"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 176 204 L 178.125 204 L 178.125 206.25 L 176 206.25 Z M 176 204 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b786e36014"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.375 204 L 162 204 L 162 206.25 L 159.375 206.25 Z M 159.375 204 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af36526d19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 177 170 L 178.125 170 L 178.125 186 L 177 186 Z M 177 170 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c6b3a39973"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.375 170 L 160 170 L 160 186 L 159.375 186 Z M 159.375 170 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5b56dbf2f1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 161 168.503906 L 177 168.503906 L 177 170 L 161 170 Z M 161 168.503906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5d4e7cbaf8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 161 186 L 177 186 L 177 187.253906 L 161 187.253906 Z M 161 186 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a3301ca863"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 176 168.503906 L 178.125 168.503906 L 178.125 171 L 176 171 Z M 176 168.503906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6c0f7683fe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.375 168.503906 L 162 168.503906 L 162 171 L 159.375 171 Z M 159.375 168.503906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c3bff25a65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 176 185 L 178.125 185 L 178.125 187.253906 L 176 187.253906 Z M 176 185 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b508761968"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.375 185 L 162 185 L 162 187.253906 L 159.375 187.253906 Z M 159.375 185 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1f753c3a4c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 196 170 L 197.121094 170 L 197.121094 186 L 196 186 Z M 196 170 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "773eb6e925"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 178.371094 170 L 179 170 L 179 186 L 178.371094 186 Z M 178.371094 170 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "45a39d3b22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 180 168.503906 L 196 168.503906 L 196 170 L 180 170 Z M 180 168.503906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c7ad851e31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 180 186 L 196 186 L 196 187.253906 L 180 187.253906 Z M 180 186 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "685ef60706"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 195 168.503906 L 197.121094 168.503906 L 197.121094 171 L 195 171 Z M 195 168.503906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "acdc59bb1a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 178.371094 168.503906 L 181 168.503906 L 181 171 L 178.371094 171 Z M 178.371094 168.503906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "210b851f6f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 195 185 L 197.121094 185 L 197.121094 187.253906 L 195 187.253906 Z M 195 185 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c3eaa235e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 178.371094 185 L 181 185 L 181 187.253906 L 178.371094 187.253906 Z M 178.371094 185 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cda3f6a93d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.527344 173.757812 L 270.777344 173.757812 L 270.777344 319.847656 L 73.527344 319.847656 Z M 73.527344 173.757812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae3458a2d0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 83 131 L 102 131 L 102 266 L 83 266 Z M 83 131 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c1161f85f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.460938 131.050781 L 101.242188 141.855469 L 78.832031 265.847656 L 19.050781 255.042969 Z M 41.460938 131.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0a38589f8f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.050781 89.0625 L 277.84375 130.417969 L 241.824219 329.6875 L 13.03125 288.332031 Z M 49.050781 89.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "68889e2c39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 97.386719 97.917969 L 277.730469 130.515625 L 241.699219 329.871094 L 61.351562 297.273438 Z M 97.386719 97.917969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f201716aa3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 57 177 L 83 177 L 83 266 L 57 266 Z M 57 177 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c6f6545809"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.460938 131.050781 L 101.242188 141.855469 L 78.832031 265.847656 L 19.050781 255.042969 Z M 41.460938 131.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "14c13d0473"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.050781 89.0625 L 277.84375 130.417969 L 241.824219 329.6875 L 13.03125 288.332031 Z M 49.050781 89.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d3ac7fd936"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63 139 L 90 139 L 90 180 L 63 180 Z M 63 139 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c9c81dce39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.460938 131.050781 L 101.242188 141.855469 L 78.832031 265.847656 L 19.050781 255.042969 Z M 41.460938 131.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "770f8c4857"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.050781 89.0625 L 277.84375 130.417969 L 241.824219 329.6875 L 13.03125 288.332031 Z M 49.050781 89.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a4632e4cdc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 154 L 60 154 L 60 203 L 45 203 Z M 45 154 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b4c0f1c203"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.460938 131.050781 L 101.242188 141.855469 L 78.832031 265.847656 L 19.050781 255.042969 Z M 41.460938 131.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0ba943cdda"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.050781 89.0625 L 277.84375 130.417969 L 241.824219 329.6875 L 13.03125 288.332031 Z M 49.050781 89.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1e1f993ccf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 57 164 L 89 164 L 89 213 L 57 213 Z M 57 164 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5e68e4a202"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.460938 131.050781 L 101.242188 141.855469 L 78.832031 265.847656 L 19.050781 255.042969 Z M 41.460938 131.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b145a9cd9b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.050781 89.0625 L 277.84375 130.417969 L 241.824219 329.6875 L 13.03125 288.332031 Z M 49.050781 89.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fa63efa0c7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31 186 L 61 186 L 61 229 L 31 229 Z M 31 186 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d41d9cd981"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.460938 131.050781 L 101.242188 141.855469 L 78.832031 265.847656 L 19.050781 255.042969 Z M 41.460938 131.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9e65790d7c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.050781 89.0625 L 277.84375 130.417969 L 241.824219 329.6875 L 13.03125 288.332031 Z M 49.050781 89.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1a88448b71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 61 198 L 89 198 L 89 238 L 61 238 Z M 61 198 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2860f38d4b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.460938 131.050781 L 101.242188 141.855469 L 78.832031 265.847656 L 19.050781 255.042969 Z M 41.460938 131.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0c8ad46801"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.050781 89.0625 L 277.84375 130.417969 L 241.824219 329.6875 L 13.03125 288.332031 Z M 49.050781 89.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0c8d067d52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 59 248 L 74 248 L 74 262 L 59 262 Z M 59 248 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d126a9f8fa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.460938 131.050781 L 101.242188 141.855469 L 78.832031 265.847656 L 19.050781 255.042969 Z M 41.460938 131.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ee7e121d09"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.050781 89.0625 L 277.84375 130.417969 L 241.824219 329.6875 L 13.03125 288.332031 Z M 49.050781 89.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 3827916241
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29 218 L 62 218 L 62 250 L 29 250 Z M 29 218 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7359818ee5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.460938 131.050781 L 101.242188 141.855469 L 78.832031 265.847656 L 19.050781 255.042969 Z M 41.460938 131.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9d23cd32a7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.050781 89.0625 L 277.84375 130.417969 L 241.824219 329.6875 L 13.03125 288.332031 Z M 49.050781 89.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ce62c9b9e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40 223 L 59 223 L 59 249 L 40 249 Z M 40 223 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab15e8e9e7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.460938 131.050781 L 101.242188 141.855469 L 78.832031 265.847656 L 19.050781 255.042969 Z M 41.460938 131.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "48a5867c18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.050781 89.0625 L 277.84375 130.417969 L 241.824219 329.6875 L 13.03125 288.332031 Z M 49.050781 89.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b5074dc34e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 39 203 L 60 203 L 60 227 L 39 227 Z M 39 203 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e0b3b17f56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.460938 131.050781 L 101.242188 141.855469 L 78.832031 265.847656 L 19.050781 255.042969 Z M 41.460938 131.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b370123df4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.050781 89.0625 L 277.84375 130.417969 L 241.824219 329.6875 L 13.03125 288.332031 Z M 49.050781 89.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cd4fb61c3a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49 173 L 59 173 L 59 201 L 49 201 Z M 49 173 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f6cb4f00c3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.460938 131.050781 L 101.242188 141.855469 L 78.832031 265.847656 L 19.050781 255.042969 Z M 41.460938 131.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "72febc2d74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.050781 89.0625 L 277.84375 130.417969 L 241.824219 329.6875 L 13.03125 288.332031 Z M 49.050781 89.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cde42a5e46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63 153 L 79 153 L 79 178 L 63 178 Z M 63 153 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b04b7c03c3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.460938 131.050781 L 101.242188 141.855469 L 78.832031 265.847656 L 19.050781 255.042969 Z M 41.460938 131.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b72f34fae7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.050781 89.0625 L 277.84375 130.417969 L 241.824219 329.6875 L 13.03125 288.332031 Z M 49.050781 89.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d968b4f382"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 58 178 L 79 178 L 79 211 L 58 211 Z M 58 178 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8a1a2b7598"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.460938 131.050781 L 101.242188 141.855469 L 78.832031 265.847656 L 19.050781 255.042969 Z M 41.460938 131.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cff49ab9c3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.050781 89.0625 L 277.84375 130.417969 L 241.824219 329.6875 L 13.03125 288.332031 Z M 49.050781 89.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d2c0b7fbba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 62 202 L 79 202 L 79 234 L 62 234 Z M 62 202 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9d1ec31173"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.460938 131.050781 L 101.242188 141.855469 L 78.832031 265.847656 L 19.050781 255.042969 Z M 41.460938 131.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "860984897f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.050781 89.0625 L 277.84375 130.417969 L 241.824219 329.6875 L 13.03125 288.332031 Z M 49.050781 89.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b9f55f39b0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67 244 L 71 244 L 71 255 L 67 255 Z M 67 244 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ff93114eb1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.460938 131.050781 L 101.242188 141.855469 L 78.832031 265.847656 L 19.050781 255.042969 Z M 41.460938 131.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c70c32ee47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.050781 89.0625 L 277.84375 130.417969 L 241.824219 329.6875 L 13.03125 288.332031 Z M 49.050781 89.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "351a0cf38b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 57 103 L 262 103 L 262 216 L 57 216 Z M 57 103 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4ac03adcd2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 72.632812 103.238281 L 261.382812 142.3125 L 246.175781 215.757812 L 57.429688 176.683594 Z M 72.632812 103.238281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "87c59e4715"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 85.859375 39.347656 L 337.035156 91.34375 L 285.039062 342.515625 L 33.863281 290.519531 Z M 85.859375 39.347656 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8bdf6055e3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 245.597656 284.863281 L 140.617188 284.863281 L 140.617188 129.699219 L 113.066406 157.25 L 113.066406 283.898438 L 111.140625 283.898438 L 111.140625 156.453125 L 140.617188 126.976562 L 140.617188 96.488281 L 155.859375 111.730469 L 177.453125 90.140625 L 245.59375 158.28125 L 245.59375 284.863281 Z M 142.539062 282.941406 L 243.667969 282.941406 L 243.667969 159.078125 L 177.453125 92.859375 L 157.21875 113.09375 L 209.378906 165.253906 L 209.378906 221.519531 L 207.457031 221.519531 L 207.457031 166.050781 L 155.863281 114.457031 L 142.539062 127.773438 Z M 142.539062 101.132812 L 142.539062 125.054688 L 154.5 113.09375 Z M 193.355469 283.886719 L 192.710938 237.011719 L 163.382812 237.011719 L 163.382812 283.902344 L 165.304688 283.902344 L 165.304688 238.933594 L 190.8125 238.933594 L 191.4375 283.914062 Z M 193.355469 283.886719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#07fbc7def8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 196.222656 171.984375 L 197.355469 171.984375 L 197.355469 203.003906 L 196.222656 203.003906 Z M 196.222656 171.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bdb80ce35e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 159.375 171.984375 L 160.511719 171.984375 L 160.511719 203.003906 L 159.375 203.003906 Z M 159.375 171.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4cbcecfb27)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 162.855469 168.503906 L 193.875 168.503906 L 193.875 169.640625 L 162.855469 169.640625 Z M 162.855469 168.503906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac2e9952ed)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 162.855469 205.351562 L 193.875 205.351562 L 193.875 206.484375 L 162.855469 206.484375 Z M 162.855469 205.351562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#25be7620e3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 196.222656 169.640625 L 196.222656 171.984375 L 197.355469 171.984375 L 197.355469 168.503906 L 193.875 168.503906 L 193.875 169.640625 Z M 196.222656 169.640625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3b0dd8dc93)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 160.511719 169.640625 L 162.855469 169.640625 L 162.855469 168.503906 L 159.375 168.503906 L 159.375 171.984375 L 160.511719 171.984375 Z M 160.511719 169.640625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e12f2f09ff)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 196.222656 205.351562 L 193.875 205.351562 L 193.875 206.484375 L 197.355469 206.484375 L 197.355469 203.003906 L 196.222656 203.003906 Z M 196.222656 205.351562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a4286495a8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 160.511719 205.351562 L 160.511719 203.003906 L 159.375 203.003906 L 159.375 206.484375 L 162.855469 206.484375 L 162.855469 205.351562 Z M 160.511719 205.351562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6d5a896695)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 196.789062 189.238281 L 197.355469 189.238281 L 197.355469 204.746094 L 196.789062 204.746094 Z M 196.789062 189.238281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3bfa954f9e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 178.371094 189.238281 L 178.9375 189.238281 L 178.9375 204.746094 L 178.371094 204.746094 Z M 178.371094 189.238281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c1dab75197)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 180.109375 187.5 L 195.617188 187.5 L 195.617188 188.066406 L 180.109375 188.066406 Z M 180.109375 187.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e70e853cd9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 180.109375 205.917969 L 195.617188 205.917969 L 195.617188 206.484375 L 180.109375 206.484375 Z M 180.109375 205.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a136f88b50)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 196.789062 188.066406 L 196.789062 189.238281 L 197.355469 189.238281 L 197.355469 187.5 L 195.617188 187.5 L 195.617188 188.066406 Z M 196.789062 188.066406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a2f3113202)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 178.9375 188.066406 L 180.109375 188.066406 L 180.109375 187.5 L 178.371094 187.5 L 178.371094 189.238281 L 178.9375 189.238281 Z M 178.9375 188.066406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0e3fdcf389)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 196.789062 205.917969 L 195.617188 205.917969 L 195.617188 206.484375 L 197.355469 206.484375 L 197.355469 204.746094 L 196.789062 204.746094 Z M 196.789062 205.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a7c87a320d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 178.9375 205.917969 L 178.9375 204.746094 L 178.371094 204.746094 L 178.371094 206.484375 L 180.109375 206.484375 L 180.109375 205.917969 Z M 178.9375 205.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb74aa9016)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 177.792969 189.238281 L 178.359375 189.238281 L 178.359375 204.746094 L 177.792969 204.746094 Z M 177.792969 189.238281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#03bc69042d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 159.375 189.238281 L 159.941406 189.238281 L 159.941406 204.746094 L 159.375 204.746094 Z M 159.375 189.238281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b716349814)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 161.113281 187.5 L 176.621094 187.5 L 176.621094 188.066406 L 161.113281 188.066406 Z M 161.113281 187.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f3d63ee0d8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 161.113281 205.917969 L 176.621094 205.917969 L 176.621094 206.484375 L 161.113281 206.484375 Z M 161.113281 205.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6172637353)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 177.792969 188.066406 L 177.792969 189.238281 L 178.359375 189.238281 L 178.359375 187.5 L 176.621094 187.5 L 176.621094 188.066406 Z M 177.792969 188.066406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e172286f0a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 159.941406 188.066406 L 161.113281 188.066406 L 161.113281 187.5 L 159.375 187.5 L 159.375 189.238281 L 159.941406 189.238281 Z M 159.941406 188.066406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#56b4a0a241)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 177.792969 205.917969 L 176.621094 205.917969 L 176.621094 206.484375 L 178.359375 206.484375 L 178.359375 204.746094 L 177.792969 204.746094 Z M 177.792969 205.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b786e36014)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 159.941406 205.917969 L 159.941406 204.746094 L 159.375 204.746094 L 159.375 206.484375 L 161.113281 206.484375 L 161.113281 205.917969 Z M 159.941406 205.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af36526d19)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 177.792969 170.242188 L 178.359375 170.242188 L 178.359375 185.75 L 177.792969 185.75 Z M 177.792969 170.242188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c6b3a39973)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 159.375 170.242188 L 159.941406 170.242188 L 159.941406 185.75 L 159.375 185.75 Z M 159.375 170.242188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5b56dbf2f1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 161.113281 168.503906 L 176.621094 168.503906 L 176.621094 169.070312 L 161.113281 169.070312 Z M 161.113281 168.503906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5d4e7cbaf8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 161.113281 186.921875 L 176.621094 186.921875 L 176.621094 187.488281 L 161.113281 187.488281 Z M 161.113281 186.921875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a3301ca863)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 177.792969 169.070312 L 177.792969 170.242188 L 178.359375 170.242188 L 178.359375 168.503906 L 176.621094 168.503906 L 176.621094 169.070312 Z M 177.792969 169.070312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6c0f7683fe)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 159.941406 169.070312 L 161.113281 169.070312 L 161.113281 168.503906 L 159.375 168.503906 L 159.375 170.242188 L 159.941406 170.242188 Z M 159.941406 169.070312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c3bff25a65)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 177.792969 186.921875 L 176.621094 186.921875 L 176.621094 187.488281 L 178.359375 187.488281 L 178.359375 185.75 L 177.792969 185.75 Z M 177.792969 186.921875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b508761968)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 159.941406 186.921875 L 159.941406 185.75 L 159.375 185.75 L 159.375 187.488281 L 161.113281 187.488281 L 161.113281 186.921875 Z M 159.941406 186.921875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1f753c3a4c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 196.789062 170.242188 L 197.355469 170.242188 L 197.355469 185.75 L 196.789062 185.75 Z M 196.789062 170.242188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#773eb6e925)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 178.371094 170.242188 L 178.9375 170.242188 L 178.9375 185.75 L 178.371094 185.75 Z M 178.371094 170.242188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#45a39d3b22)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 180.109375 168.503906 L 195.617188 168.503906 L 195.617188 169.070312 L 180.109375 169.070312 Z M 180.109375 168.503906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c7ad851e31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 180.109375 186.921875 L 195.617188 186.921875 L 195.617188 187.488281 L 180.109375 187.488281 Z M 180.109375 186.921875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#685ef60706)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 196.789062 169.070312 L 196.789062 170.242188 L 197.355469 170.242188 L 197.355469 168.503906 L 195.617188 168.503906 L 195.617188 169.070312 Z M 196.789062 169.070312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#acdc59bb1a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 178.9375 169.070312 L 180.109375 169.070312 L 180.109375 168.503906 L 178.371094 168.503906 L 178.371094 170.242188 L 178.9375 170.242188 Z M 178.9375 169.070312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#210b851f6f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 196.789062 186.921875 L 195.617188 186.921875 L 195.617188 187.488281 L 197.355469 187.488281 L 197.355469 185.75 L 196.789062 185.75 Z M 196.789062 186.921875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c3eaa235e6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 178.9375 186.921875 L 178.9375 185.75 L 178.371094 185.75 L 178.371094 187.488281 L 180.109375 187.488281 L 180.109375 186.921875 Z M 178.9375 186.921875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.500731, 106.137357)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.1875 -3.546875 C 3.5 -2.929688 2.734375 -2.453125 1.890625 -2.109375 C 1.054688 -1.773438 0.304688 -1.640625 -0.359375 -1.703125 L -0.65625 -2.796875 C -0.0195312 -2.753906 0.671875 -2.878906 1.421875 -3.171875 C 2.171875 -3.460938 2.84375 -3.867188 3.4375 -4.390625 C 4.289062 -5.128906 4.789062 -5.835938 4.9375 -6.515625 C 5.082031 -7.191406 4.9375 -7.773438 4.5 -8.265625 C 4.175781 -8.640625 3.800781 -8.835938 3.375 -8.859375 C 2.945312 -8.890625 2.507812 -8.816406 2.0625 -8.640625 C 1.625 -8.472656 1.050781 -8.207031 0.34375 -7.84375 C -0.519531 -7.382812 -1.234375 -7.050781 -1.796875 -6.84375 C -2.359375 -6.644531 -2.941406 -6.582031 -3.546875 -6.65625 C -4.148438 -6.738281 -4.707031 -7.066406 -5.21875 -7.640625 C -5.632812 -8.117188 -5.882812 -8.660156 -5.96875 -9.265625 C -6.0625 -9.878906 -5.953125 -10.53125 -5.640625 -11.21875 C -5.328125 -11.90625 -4.789062 -12.585938 -4.03125 -13.265625 C -3.488281 -13.742188 -2.894531 -14.132812 -2.25 -14.4375 C -1.601562 -14.75 -0.976562 -14.941406 -0.375 -15.015625 L -0.015625 -13.921875 C -0.628906 -13.835938 -1.21875 -13.660156 -1.78125 -13.390625 C -2.351562 -13.128906 -2.851562 -12.804688 -3.28125 -12.421875 C -4.101562 -11.703125 -4.578125 -11 -4.703125 -10.3125 C -4.835938 -9.632812 -4.6875 -9.046875 -4.25 -8.546875 C -3.914062 -8.171875 -3.535156 -7.96875 -3.109375 -7.9375 C -2.691406 -7.90625 -2.253906 -7.976562 -1.796875 -8.15625 C -1.347656 -8.34375 -0.765625 -8.625 -0.046875 -9 C 0.785156 -9.4375 1.484375 -9.753906 2.046875 -9.953125 C 2.617188 -10.160156 3.203125 -10.226562 3.796875 -10.15625 C 4.390625 -10.09375 4.9375 -9.773438 5.4375 -9.203125 C 5.851562 -8.722656 6.101562 -8.175781 6.1875 -7.5625 C 6.28125 -6.945312 6.164062 -6.289062 5.84375 -5.59375 C 5.519531 -4.90625 4.96875 -4.222656 4.1875 -3.546875 Z M 4.1875 -3.546875 "
  }))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(113.480777, 95.296597)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M -2.53125 -11.953125 L -6.203125 -9.546875 L -6.828125 -10.5 L 1.609375 -16.0625 L 2.234375 -15.109375 L -1.421875 -12.6875 L 4.84375 -3.1875 L 3.734375 -2.453125 Z M -2.53125 -11.953125 "
  }))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.101556, 86.667752)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 6.484375 -2.859375 C 5.003906 -2.179688 3.660156 -2.078125 2.453125 -2.546875 C 1.242188 -3.015625 0.269531 -4.054688 -0.46875 -5.671875 L -3.46875 -12.1875 L -2.28125 -12.734375 L 0.703125 -6.25 C 1.304688 -4.9375 2.050781 -4.09375 2.9375 -3.71875 C 3.832031 -3.351562 4.847656 -3.425781 5.984375 -3.9375 C 7.117188 -4.46875 7.832031 -5.191406 8.125 -6.109375 C 8.425781 -7.023438 8.273438 -8.140625 7.671875 -9.453125 L 4.6875 -15.9375 L 5.84375 -16.46875 L 8.84375 -9.953125 C 9.582031 -8.335938 9.738281 -6.921875 9.3125 -5.703125 C 8.894531 -4.492188 7.953125 -3.546875 6.484375 -2.859375 Z M 6.484375 -2.859375 "
  }))))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(145.379714, 78.76732)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M -1.265625 -12.625 L 3.640625 -13.9375 C 4.921875 -14.28125 6.117188 -14.320312 7.234375 -14.0625 C 8.359375 -13.8125 9.3125 -13.300781 10.09375 -12.53125 C 10.875 -11.757812 11.425781 -10.785156 11.75 -9.609375 C 12.0625 -8.441406 12.070312 -7.328125 11.78125 -6.265625 C 11.488281 -5.210938 10.914062 -4.296875 10.0625 -3.515625 C 9.21875 -2.742188 8.15625 -2.1875 6.875 -1.84375 L 1.96875 -0.53125 Z M 6.53125 -2.9375 C 7.582031 -3.21875 8.445312 -3.675781 9.125 -4.3125 C 9.8125 -4.945312 10.273438 -5.691406 10.515625 -6.546875 C 10.753906 -7.398438 10.75 -8.304688 10.5 -9.265625 C 10.238281 -10.234375 9.785156 -11.03125 9.140625 -11.65625 C 8.503906 -12.289062 7.734375 -12.710938 6.828125 -12.921875 C 5.921875 -13.128906 4.941406 -13.09375 3.890625 -12.8125 L 0.3125 -11.859375 L 2.953125 -1.984375 Z M 6.53125 -2.9375 "
  }))))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(165.545465, 74.107271)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.4375 -12.671875 L 1.75 -12.84375 L 3.328125 -0.421875 L 2.015625 -0.25 Z M 0.4375 -12.671875 "
  }))))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.821843, 72.746257)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.5 0.171875 C 6.269531 0.160156 5.148438 -0.125 4.140625 -0.6875 C 3.140625 -1.257812 2.359375 -2.03125 1.796875 -3 C 1.234375 -3.96875 0.957031 -5.050781 0.96875 -6.25 C 0.976562 -7.457031 1.269531 -8.539062 1.84375 -9.5 C 2.425781 -10.457031 3.222656 -11.207031 4.234375 -11.75 C 5.253906 -12.300781 6.378906 -12.570312 7.609375 -12.5625 C 8.847656 -12.550781 9.960938 -12.265625 10.953125 -11.703125 C 11.953125 -11.140625 12.726562 -10.367188 13.28125 -9.390625 C 13.84375 -8.421875 14.117188 -7.332031 14.109375 -6.125 C 14.097656 -4.925781 13.804688 -3.84375 13.234375 -2.875 C 12.660156 -1.90625 11.867188 -1.148438 10.859375 -0.609375 C 9.859375 -0.078125 8.738281 0.179688 7.5 0.171875 Z M 7.515625 -1.015625 C 8.503906 -1.003906 9.398438 -1.21875 10.203125 -1.65625 C 11.003906 -2.09375 11.632812 -2.707031 12.09375 -3.5 C 12.5625 -4.289062 12.796875 -5.171875 12.796875 -6.140625 C 12.804688 -7.117188 12.585938 -8.003906 12.140625 -8.796875 C 11.691406 -9.597656 11.066406 -10.222656 10.265625 -10.671875 C 9.472656 -11.128906 8.582031 -11.363281 7.59375 -11.375 C 6.613281 -11.382812 5.71875 -11.164062 4.90625 -10.71875 C 4.09375 -10.28125 3.453125 -9.664062 2.984375 -8.875 C 2.523438 -8.09375 2.289062 -7.210938 2.28125 -6.234375 C 2.28125 -5.265625 2.503906 -4.378906 2.953125 -3.578125 C 3.398438 -2.773438 4.023438 -2.148438 4.828125 -1.703125 C 5.640625 -1.253906 6.535156 -1.023438 7.515625 -1.015625 Z M 7.515625 -1.015625 "
  }))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(197.760356, 73.670528)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.859375 0.359375 C 1.597656 0.316406 1.390625 0.1875 1.234375 -0.03125 C 1.078125 -0.25 1.019531 -0.488281 1.0625 -0.75 C 1.101562 -1.03125 1.222656 -1.25 1.421875 -1.40625 C 1.628906 -1.5625 1.863281 -1.617188 2.125 -1.578125 C 2.382812 -1.546875 2.597656 -1.425781 2.765625 -1.21875 C 2.929688 -1.007812 2.992188 -0.765625 2.953125 -0.484375 C 2.910156 -0.222656 2.78125 -0.0078125 2.5625 0.15625 C 2.351562 0.320312 2.117188 0.390625 1.859375 0.359375 Z M 1.859375 0.359375 "
  }))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(207.485734, 75.106551)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.6875 -10.375 C 11.226562 -9.96875 12.335938 -9.28125 13.015625 -8.3125 C 13.703125 -7.34375 13.875 -6.21875 13.53125 -4.9375 C 13.195312 -3.644531 12.492188 -2.75 11.421875 -2.25 C 10.359375 -1.75 9.054688 -1.703125 7.515625 -2.109375 L 4.265625 -2.96875 L 3.25 0.859375 L 1.96875 0.515625 L 5.15625 -11.578125 Z M 7.765625 -3.234375 C 8.960938 -2.910156 9.945312 -2.925781 10.71875 -3.28125 C 11.5 -3.644531 12.015625 -4.304688 12.265625 -5.265625 C 12.523438 -6.234375 12.40625 -7.066406 11.90625 -7.765625 C 11.414062 -8.460938 10.570312 -8.972656 9.375 -9.296875 L 6.15625 -10.140625 L 4.546875 -4.078125 Z M 7.765625 -3.234375 "
  }))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(225.510478, 80.499062)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 6.578125 -10.828125 L 7.8125 -10.328125 L 3.109375 1.265625 L 1.875 0.765625 Z M 6.578125 -10.828125 "
  }))))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(236.028902, 84.942175)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.078125 4.296875 L 9.515625 5.296875 L 1.78125 0.984375 L 7.875 -9.953125 L 15.375 -5.765625 L 14.8125 -4.765625 L 8.46875 -8.296875 L 6.3125 -4.40625 L 11.96875 -1.265625 L 11.421875 -0.28125 L 5.765625 -3.421875 L 3.5 0.640625 Z M 10.078125 4.296875 "
  }))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(251.378687, 93.968868)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.28125 -1 L 4.671875 -0.53125 L 2.65625 2.0625 L 1.609375 1.25 L 9.296875 -8.625 L 10.34375 -7.8125 L 5.703125 -1.84375 L 16.140625 -3.3125 L 17.328125 -2.375 L 9.578125 -1.21875 L 9.953125 7.734375 L 8.703125 6.765625 Z M 8.28125 -1 "
  }))))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(265.740946, 105.637476)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 17.6875 0.671875 L 8.5 9.171875 L 7.75 8.375 L 9.734375 -4.4375 L 2.28125 2.46875 L 1.375 1.484375 L 10.5625 -7.015625 L 11.3125 -6.203125 L 9.34375 6.59375 L 16.796875 -0.296875 Z M 17.6875 0.671875 "
  }))))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(279.136695, 120.935072)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 6.984375 8.4375 L 6.03125 9.0625 L 1.125 1.6875 L 11.546875 -5.25 L 16.3125 1.90625 L 15.359375 2.546875 L 11.328125 -3.5 L 7.625 -1.03125 L 11.203125 4.359375 L 10.265625 4.96875 L 6.6875 -0.421875 L 2.8125 2.171875 Z M 6.984375 8.4375 "
  }))))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.608787, 136.236622)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.78125 1.734375 C 0.65625 1.503906 0.640625 1.257812 0.734375 1 C 0.828125 0.75 0.992188 0.5625 1.234375 0.4375 C 1.484375 0.3125 1.726562 0.289062 1.96875 0.375 C 2.207031 0.457031 2.390625 0.613281 2.515625 0.84375 C 2.628906 1.070312 2.648438 1.3125 2.578125 1.5625 C 2.503906 1.820312 2.34375 2.015625 2.09375 2.140625 C 1.851562 2.265625 1.601562 2.285156 1.34375 2.203125 C 1.082031 2.117188 0.894531 1.960938 0.78125 1.734375 Z M 0.78125 1.734375 "
  }))))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(293.144971, 144.811274)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 17.953125 14.28125 L 4.75 14.234375 L 4.296875 12.90625 L 13.265625 6.046875 L 1.96875 5.921875 L 1.546875 4.625 L 12.078125 -3.328125 L 12.515625 -2.046875 L 3.4375 4.796875 L 14.828125 4.921875 L 15.21875 6.09375 L 6.125 13.015625 L 17.546875 13.078125 Z M 17.953125 14.28125 "
  }))))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(300.442441, 169.223941)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 14.03125 10.765625 L 1.625 12.390625 L 1.484375 11.3125 L 10.5 2.015625 L 0.4375 3.328125 L 0.265625 2.015625 L 12.671875 0.390625 L 12.8125 1.46875 L 3.796875 10.78125 L 13.859375 9.46875 Z M 14.03125 10.765625 "
  }))))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(302.520639, 189.449879)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.8125 10.921875 L -0.328125 10.890625 L -0.0625 2.03125 L 12.453125 2.40625 L 12.203125 11 L 11.0625 10.96875 L 11.28125 3.703125 L 6.828125 3.5625 L 6.625 10.03125 L 5.5 10 L 5.703125 3.53125 L 1.046875 3.390625 Z M 0.8125 10.921875 "
  }))))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(301.5074, 207.27745)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.4375 6.359375 L 11.1875 2.03125 L 12.3125 2.234375 L 10.578125 12.1875 L 9.453125 11.984375 L 10.203125 7.65625 L -1 5.703125 L -0.765625 4.40625 Z M 10.4375 6.359375 "
  }))))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(298.405265, 223.122968)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M -3.3125 10.046875 L 1.390625 8.59375 C 1.460938 8.28125 1.550781 7.957031 1.65625 7.625 L 2.71875 4.4375 L -1.046875 3.1875 L -0.640625 1.921875 L 11.25 5.84375 L 9.78125 10.296875 C 9.28125 11.816406 8.519531 12.882812 7.5 13.5 C 6.488281 14.125 5.347656 14.226562 4.078125 13.8125 C 3.148438 13.507812 2.445312 13.015625 1.96875 12.328125 C 1.488281 11.648438 1.253906 10.828125 1.265625 9.859375 L -3.78125 11.421875 Z M 2.75 7.9375 C 2.351562 9.113281 2.3125 10.097656 2.625 10.890625 C 2.9375 11.691406 3.5625 12.25 4.5 12.5625 C 5.46875 12.882812 6.3125 12.816406 7.03125 12.359375 C 7.75 11.898438 8.304688 11.082031 8.703125 9.90625 L 9.75 6.75 L 3.796875 4.78125 Z M 2.75 7.9375 "
  }))))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(292.045495, 240.783981)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M -4.015625 10.375 L -5.03125 9.859375 L -0.359375 0.703125 L 0.453125 1.109375 L 6.015625 13.28125 L 9.71875 6 L 10.734375 6.515625 L 6.234375 15.34375 L 5.40625 14.921875 L -0.15625 2.8125 Z M -4.015625 10.375 "
  }))))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(283.749734, 256.1814)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M -3.046875 9.984375 L 1.015625 4.3125 L -0.828125 1.140625 L -0.015625 0.03125 L 6.796875 11.96875 L 6.03125 13.03125 L -7.453125 10.375 L -6.640625 9.25 Z M -1.890625 10.21875 L 5.3125 11.703125 L 1.609375 5.328125 Z M -1.890625 10.21875 "
  }))))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe6e4",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(272.268496, 271.084757)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cda3f6a93d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 179.085938 319.835938 C 108.394531 319.835938 50.84375 262.285156 50.84375 191.59375 C 50.84375 120.902344 108.394531 63.347656 179.085938 63.347656 C 249.777344 63.347656 307.332031 120.902344 307.332031 191.59375 C 307.332031 262.285156 249.777344 319.835938 179.085938 319.835938 Z M 179.085938 65.242188 C 109.40625 65.242188 52.738281 121.910156 52.738281 191.59375 C 52.738281 261.273438 109.40625 317.941406 179.085938 317.941406 C 248.769531 317.941406 305.433594 261.273438 305.433594 191.59375 C 305.433594 121.910156 248.769531 65.242188 179.085938 65.242188 Z M 179.085938 65.242188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae3458a2d0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c1161f85f3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0a38589f8f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#68889e2c39)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 141.925781 311.835938 C 141.734375 311.800781 141.546875 311.769531 141.359375 311.734375 C 133.933594 310.347656 126.652344 308.113281 119.714844 305.097656 C 106.15625 299.203125 93.804688 290.203125 84 279.070312 C 83.8125 278.859375 83.835938 278.539062 84.046875 278.355469 C 84.257812 278.167969 84.578125 278.1875 84.765625 278.398438 C 104.988281 301.359375 134.097656 313.722656 164.628906 312.320312 C 191.378906 311.09375 216.050781 299.523438 234.09375 279.742188 C 252.144531 259.957031 261.40625 234.332031 260.175781 207.582031 C 258.949219 180.832031 247.378906 156.164062 227.597656 138.117188 C 207.8125 120.070312 182.1875 110.808594 155.4375 112.035156 C 131.28125 113.144531 108.351562 122.933594 90.871094 139.605469 C 90.667969 139.800781 90.347656 139.792969 90.152344 139.589844 C 89.957031 139.382812 89.964844 139.0625 90.167969 138.867188 C 98.820312 130.617188 108.742188 124.027344 119.65625 119.28125 C 130.949219 114.367188 142.976562 111.585938 155.390625 111.019531 C 169.046875 110.390625 182.417969 112.457031 195.132812 117.160156 C 207.414062 121.703125 218.566406 128.5 228.28125 137.363281 C 238 146.230469 245.789062 156.710938 251.4375 168.523438 C 257.285156 180.753906 260.570312 193.878906 261.195312 207.535156 C 261.824219 221.191406 259.753906 234.5625 255.050781 247.277344 C 250.511719 259.558594 243.714844 270.710938 234.847656 280.425781 C 225.984375 290.144531 215.5 297.933594 203.6875 303.582031 C 191.457031 309.429688 178.332031 312.714844 164.675781 313.339844 C 157.035156 313.691406 149.382812 313.183594 141.925781 311.835938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f201716aa3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c6f6545809)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#14c13d0473)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 81.894531 275.058594 C 74.539062 264.125 68.507812 252.253906 64.445312 239.707031 C 60.390625 227.195312 58.316406 213.902344 59.476562 200.753906 C 60.164062 192.941406 62.003906 185.328125 65.066406 178.101562 C 65.429688 177.242188 64.121094 176.609375 63.753906 177.472656 C 58.363281 190.183594 56.785156 204.101562 58.21875 217.785156 C 59.625 231.167969 63.75 244.199219 69.519531 256.324219 C 72.75 263.117188 76.503906 269.648438 80.699219 275.886719 C 81.222656 276.664062 82.417969 275.835938 81.894531 275.058594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d3ac7fd936)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c9c81dce39)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#770f8c4857)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 64.378906 178.769531 C 69.152344 175.375 74.261719 171.824219 77.707031 167.003906 C 81.28125 162.003906 82.667969 155.914062 84.570312 150.175781 C 85.667969 146.859375 86.96875 143.566406 88.964844 140.675781 C 89.355469 140.113281 88.578125 139.40625 88.136719 139.96875 C 84.050781 145.152344 78.324219 148.550781 73.300781 152.707031 C 70.925781 154.671875 68.898438 156.898438 67.394531 159.605469 C 65.902344 162.285156 64.96875 165.253906 64.398438 168.257812 C 63.730469 171.789062 63.550781 175.394531 63.519531 178.980469 C 63.515625 179.683594 64.601562 179.582031 64.605469 178.882812 C 64.664062 172.789062 65.152344 166.421875 67.945312 160.894531 C 69.398438 158.019531 71.449219 155.648438 73.921875 153.605469 C 76.308594 151.625 78.84375 149.835938 81.292969 147.9375 C 84.085938 145.777344 86.773438 143.460938 88.964844 140.675781 C 88.6875 140.441406 88.414062 140.203125 88.136719 139.96875 C 84.652344 145.015625 83.257812 151.007812 81.351562 156.742188 C 80.402344 159.597656 79.300781 162.429688 77.730469 165.003906 C 76.164062 167.570312 74.042969 169.742188 71.789062 171.710938 C 69.246094 173.933594 66.507812 175.917969 63.757812 177.871094 C 63.1875 178.277344 63.808594 179.175781 64.378906 178.769531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a4632e4cdc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b4c0f1c203)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0ba943cdda)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 59.492188 200.222656 C 60.042969 194.289062 59.132812 188.484375 57.078125 182.910156 C 56.019531 180.050781 54.863281 177.234375 54.105469 174.273438 C 53.355469 171.328125 52.925781 168.296875 52.808594 165.257812 C 52.671875 161.871094 52.949219 158.480469 53.601562 155.152344 C 53.71875 154.558594 52.8125 154.242188 52.574219 154.820312 C 51.019531 158.5625 49.441406 162.300781 48.03125 166.105469 C 46.707031 169.664062 45.582031 173.382812 45.628906 177.214844 C 45.703125 183.417969 49.191406 188.535156 52.679688 193.371094 C 54.71875 196.195312 56.753906 199.042969 58.191406 202.230469 C 58.476562 202.867188 59.507812 202.5 59.21875 201.855469 C 56.792969 196.488281 52.734375 192.171875 49.777344 187.125 C 48.300781 184.609375 47.179688 181.867188 46.835938 178.953125 C 46.375 175.082031 47.355469 171.230469 48.640625 167.605469 C 50.117188 163.441406 51.863281 159.371094 53.558594 155.292969 C 53.214844 155.179688 52.871094 155.070312 52.527344 154.957031 C 51.398438 160.726562 51.398438 166.714844 52.582031 172.472656 C 53.183594 175.398438 54.121094 178.203125 55.183594 180.988281 C 56.296875 183.910156 57.375 186.828125 57.953125 189.910156 C 58.574219 193.242188 58.730469 196.652344 58.417969 200.027344 C 58.351562 200.722656 59.425781 200.921875 59.492188 200.222656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1e1f993ccf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5e68e4a202)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b145a9cd9b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 59.28125 211.765625 C 59.503906 207.710938 62.042969 204.332031 64.867188 201.609375 C 67.597656 198.972656 70.804688 197.011719 73.820312 194.738281 C 76.664062 192.597656 79.007812 190.066406 80.492188 186.804688 C 82.007812 183.484375 82.757812 179.871094 83.605469 176.339844 C 84.550781 172.402344 85.59375 168.300781 88.109375 165.035156 C 88.464844 164.574219 87.882812 163.816406 87.382812 164.234375 C 84.421875 166.683594 81.410156 169.183594 79.167969 172.339844 C 76.925781 175.5 75.753906 179.261719 73.191406 182.214844 C 69.085938 186.949219 62.914062 190.179688 60.660156 196.335938 C 59.097656 200.597656 59.945312 205.4375 57.90625 209.554688 C 57.59375 210.183594 58.578125 210.65625 58.890625 210.027344 C 60.664062 206.445312 60.300781 202.367188 61.144531 198.550781 C 61.867188 195.269531 63.8125 192.617188 66.171875 190.304688 C 68.445312 188.078125 70.988281 186.148438 73.183594 183.84375 C 74.304688 182.664062 75.308594 181.390625 76.144531 180 C 77.183594 178.261719 77.96875 176.394531 78.976562 174.644531 C 81.199219 170.804688 84.628906 167.921875 88.003906 165.128906 C 87.761719 164.863281 87.519531 164.59375 87.277344 164.328125 C 82.726562 170.230469 82.691406 178.148438 80.109375 184.894531 C 79.433594 186.65625 78.578125 188.359375 77.414062 189.851562 C 76.257812 191.324219 74.863281 192.574219 73.382812 193.703125 C 70.4375 195.945312 67.300781 197.871094 64.570312 200.394531 C 61.402344 203.324219 58.453125 207.097656 58.207031 211.574219 C 58.167969 212.265625 59.242188 212.464844 59.28125 211.765625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fa63efa0c7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d41d9cd981)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9e65790d7c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 60.789062 228.074219 C 59.070312 225.058594 56.953125 222.292969 54.496094 219.847656 C 52.144531 217.507812 49.488281 215.597656 46.699219 213.824219 C 44.046875 212.132812 41.316406 210.503906 38.996094 208.359375 C 36.457031 206.011719 34.882812 203.117188 34.179688 199.738281 C 33.769531 197.757812 33.574219 195.742188 33.347656 193.734375 C 33.089844 191.484375 32.839844 189.234375 32.585938 186.980469 C 32.253906 187.101562 31.921875 187.222656 31.59375 187.339844 C 34.734375 193.339844 38.035156 199.578125 43.390625 203.917969 C 46.164062 206.164062 49.488281 207.632812 52.160156 210.003906 C 54.542969 212.121094 56.136719 214.960938 57.273438 217.902344 C 58.578125 221.28125 59.320312 224.851562 59.800781 228.433594 C 59.890625 229.125 60.980469 229.035156 60.882812 228.335938 C 60.070312 222.199219 58.527344 215.425781 54.328125 210.648438 C 51.96875 207.964844 48.785156 206.382812 45.871094 204.398438 C 42.925781 202.390625 40.496094 199.800781 38.433594 196.902344 C 36.152344 193.691406 34.3125 190.199219 32.488281 186.71875 C 32.230469 186.222656 31.441406 186.570312 31.496094 187.078125 C 31.9375 191 32.230469 194.980469 32.910156 198.867188 C 33.480469 202.144531 34.617188 205.1875 36.839844 207.707031 C 38.914062 210.058594 41.53125 211.816406 44.152344 213.492188 C 46.996094 215.304688 49.84375 217.078125 52.363281 219.335938 C 55.367188 222.027344 57.898438 225.195312 59.894531 228.695312 C 60.242188 229.304688 61.136719 228.679688 60.789062 228.074219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1a88448b71)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2860f38d4b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0c8ad46801)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 63.757812 237.25 C 63.566406 234.09375 64.296875 230.921875 65.902344 228.191406 C 67.480469 225.511719 69.941406 223.539062 71.875 221.136719 C 75.511719 216.621094 76.855469 210.78125 80.273438 206.136719 C 82.355469 203.304688 85.253906 201.433594 88.214844 199.628906 C 88.613281 199.386719 88.460938 198.703125 88 198.644531 C 84.949219 198.253906 81.792969 198.253906 78.832031 199.175781 C 75.792969 200.125 73.304688 202.117188 71.519531 204.734375 C 69.601562 207.542969 68.492188 210.769531 67.597656 214.027344 C 67.082031 215.898438 66.632812 217.792969 66.105469 219.667969 C 65.585938 221.527344 64.9375 223.34375 64.269531 225.160156 C 62.878906 228.96875 61.484375 232.933594 62.050781 237.054688 C 62.148438 237.75 63.234375 237.65625 63.140625 236.957031 C 62.652344 233.40625 63.691406 229.96875 64.882812 226.660156 C 66.085938 223.316406 67.167969 219.996094 68.054688 216.558594 C 69.597656 210.582031 71.613281 203.414062 77.824219 200.714844 C 80.957031 199.355469 84.472656 199.292969 87.804688 199.71875 C 87.734375 199.390625 87.664062 199.058594 87.589844 198.730469 C 84.90625 200.367188 82.203125 202.070312 80.164062 204.507812 C 78.257812 206.785156 76.949219 209.480469 75.691406 212.152344 C 74.417969 214.863281 73.183594 217.640625 71.355469 220.03125 C 69.445312 222.527344 66.949219 224.523438 65.246094 227.183594 C 63.320312 230.195312 62.457031 233.792969 62.671875 237.347656 C 62.710938 238.046875 63.800781 237.953125 63.757812 237.25 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0c8d067d52)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d126a9f8fa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ee7e121d09)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 73.152344 260.863281 C 69.570312 255.839844 65.042969 251.570312 59.828125 248.277344 C 59.234375 247.902344 58.765625 248.890625 59.355469 249.261719 C 64.40625 252.449219 68.789062 256.621094 72.257812 261.484375 C 72.664062 262.058594 73.5625 261.433594 73.152344 260.863281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3827916241)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7359818ee5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9d23cd32a7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 60.230469 248.640625 C 57.675781 247.183594 54.992188 245.9375 52.5625 244.273438 C 50.226562 242.671875 48.085938 240.765625 46.378906 238.5 C 44.652344 236.210938 43.558594 233.6875 42.660156 230.980469 C 41.726562 228.160156 40.5 225.4375 38.535156 223.167969 C 36.480469 220.796875 33.691406 218.992188 30.460938 219.097656 C 30.539062 219.449219 30.621094 219.804688 30.699219 220.152344 C 36.492188 218.121094 42.8125 221.167969 46.300781 225.867188 C 48.027344 228.191406 49.199219 230.867188 50.050781 233.621094 C 50.515625 235.128906 50.851562 236.679688 51.355469 238.175781 C 51.832031 239.585938 52.503906 240.921875 53.324219 242.167969 C 55.203125 245.015625 57.742188 247.363281 60.226562 249.671875 C 60.742188 250.148438 61.449219 249.316406 60.9375 248.839844 C 58.597656 246.671875 56.226562 244.480469 54.417969 241.835938 C 53.507812 240.503906 52.796875 239.082031 52.300781 237.546875 C 51.78125 235.949219 51.425781 234.304688 50.902344 232.707031 C 49.074219 227.105469 45.636719 221.8125 39.972656 219.546875 C 36.902344 218.320312 33.46875 218.023438 30.320312 219.128906 C 29.722656 219.339844 29.957031 220.207031 30.558594 220.183594 C 33.578125 220.089844 36.199219 221.976562 38.011719 224.242188 C 39.957031 226.667969 40.980469 229.449219 41.96875 232.355469 C 43.730469 237.53125 47.082031 241.753906 51.542969 244.886719 C 54.136719 246.710938 57.011719 248.058594 59.757812 249.625 C 60.371094 249.976562 60.835938 248.988281 60.230469 248.640625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ce62c9b9e9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab15e8e9e7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#48a5867c18)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 58.753906 247.835938 C 54.789062 244.773438 51.375 241.046875 48.679688 236.820312 C 47.320312 234.683594 46.214844 232.433594 45.183594 230.125 C 44.171875 227.855469 43.132812 225.578125 41.558594 223.636719 C 41.265625 223.273438 40.664062 223.6875 40.960938 224.050781 C 42.601562 226.078125 43.644531 228.460938 44.699219 230.824219 C 45.722656 233.109375 46.855469 235.332031 48.214844 237.4375 C 50.914062 241.628906 54.335938 245.339844 58.277344 248.390625 C 58.648438 248.675781 59.125 248.125 58.753906 247.835938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b5074dc34e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e0b3b17f56)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b370123df4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 59.609375 226.011719 C 57.78125 221.371094 54.953125 217.152344 51.320312 213.730469 C 47.59375 210.21875 42.984375 207.605469 40 203.355469 C 39.730469 202.96875 39.132812 203.382812 39.402344 203.765625 C 42.289062 207.875 46.648438 210.480469 50.316406 213.792969 C 54.109375 217.21875 57.054688 221.511719 58.925781 226.261719 C 59.097656 226.695312 59.78125 226.449219 59.609375 226.011719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd4fb61c3a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f6cb4f00c3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#72febc2d74)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 58.253906 200.203125 C 57.714844 197.886719 57.171875 195.550781 56.210938 193.363281 C 55.257812 191.199219 53.894531 189.25 52.855469 187.128906 C 50.851562 183.023438 49.867188 178.488281 49.945312 173.925781 C 49.953125 173.460938 49.226562 173.527344 49.21875 173.992188 C 49.144531 178.523438 50.105469 183.0625 52.0625 187.152344 C 53.082031 189.28125 54.441406 191.226562 55.417969 193.371094 C 56.449219 195.628906 57.011719 198.050781 57.570312 200.453125 C 57.675781 200.90625 58.359375 200.652344 58.253906 200.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cde42a5e46)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b04b7c03c3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b72f34fae7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 64.632812 177.519531 C 65.925781 175.441406 67.21875 173.359375 68.511719 171.277344 C 69.769531 169.253906 71.117188 167.257812 72.21875 165.136719 C 72.71875 164.171875 73.140625 163.171875 73.453125 162.128906 C 73.792969 160.980469 74.023438 159.804688 74.488281 158.699219 C 75.316406 156.726562 76.691406 155.046875 78.433594 153.808594 C 78.816406 153.535156 78.402344 152.9375 78.019531 153.210938 C 76.371094 154.382812 75.019531 155.929688 74.121094 157.742188 C 73.085938 159.847656 72.839844 162.222656 71.808594 164.335938 C 70.746094 166.511719 69.359375 168.539062 68.082031 170.597656 C 66.714844 172.800781 65.347656 175 63.980469 177.203125 C 63.730469 177.601562 64.390625 177.914062 64.632812 177.519531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d968b4f382)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8a1a2b7598)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cff49ab9c3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 59.460938 210.222656 C 60.109375 207.628906 60.761719 205.007812 61.898438 202.574219 C 62.902344 200.421875 64.332031 198.558594 65.96875 196.851562 C 69.179688 193.503906 72.839844 190.6875 75.410156 186.757812 C 76.914062 184.457031 78.0625 181.957031 78.894531 179.335938 C 79.035156 178.890625 78.316406 178.765625 78.175781 179.207031 C 76.65625 184.003906 73.945312 188.152344 70.351562 191.648438 C 67.121094 194.789062 63.53125 197.664062 61.472656 201.777344 C 60.164062 204.394531 59.453125 207.265625 58.746094 210.09375 C 58.632812 210.546875 59.347656 210.675781 59.460938 210.222656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d2c0b7fbba)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9d1ec31173)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#860984897f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 63.378906 233.390625 C 64.121094 228.976562 66.105469 224.960938 68.171875 221.039062 C 69.203125 219.085938 70.257812 217.144531 71.199219 215.144531 C 72.136719 213.164062 72.816406 211.082031 73.707031 209.082031 C 74.210938 207.953125 74.824219 206.890625 75.664062 205.976562 C 76.542969 205.015625 77.585938 204.230469 78.621094 203.449219 C 78.996094 203.167969 78.582031 202.570312 78.207031 202.851562 C 76.515625 204.128906 74.882812 205.441406 73.796875 207.296875 C 72.632812 209.285156 72.011719 211.550781 71.082031 213.652344 C 69.226562 217.84375 66.785156 221.746094 64.941406 225.941406 C 63.910156 228.289062 63.089844 230.726562 62.660156 233.257812 C 62.582031 233.71875 63.300781 233.851562 63.378906 233.390625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b9f55f39b0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ff93114eb1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c70c32ee47)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 69.894531 253.773438 C 69.558594 252.109375 69.25 250.371094 69.605469 248.683594 C 69.769531 247.921875 70.109375 247.207031 70.203125 246.425781 C 70.289062 245.714844 70.203125 245.023438 69.996094 244.339844 C 69.886719 243.976562 69.371094 244.0625 69.296875 244.398438 C 68.96875 245.929688 67.898438 247.246094 67.796875 248.816406 C 67.699219 250.316406 68.28125 251.75 68.863281 253.097656 C 69.050781 253.527344 69.734375 253.28125 69.546875 252.847656 C 68.972656 251.507812 68.324219 250.023438 68.558594 248.53125 C 68.675781 247.78125 69.078125 247.148438 69.386719 246.46875 C 69.667969 245.847656 69.871094 245.195312 70.011719 244.527344 C 69.78125 244.546875 69.546875 244.566406 69.3125 244.589844 C 69.828125 246.300781 68.933594 247.675781 68.769531 249.34375 C 68.617188 250.855469 68.871094 252.359375 69.171875 253.835938 C 69.261719 254.292969 69.988281 254.234375 69.894531 253.773438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#351a0cf38b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ac03adcd2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#87c59e4715)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e3de",
    d: "M 159.449219 316.507812 C 90.222656 302.175781 45.53125 234.152344 59.863281 164.925781 C 74.195312 95.703125 142.21875 51.011719 211.441406 65.34375 C 280.667969 79.671875 325.355469 147.699219 311.027344 216.921875 C 296.695312 286.144531 228.671875 330.835938 159.449219 316.507812 Z M 211.058594 67.199219 C 142.824219 53.074219 75.84375 97.078125 61.71875 165.3125 C 47.59375 233.546875 91.597656 300.523438 159.832031 314.648438 C 228.066406 328.777344 295.042969 284.773438 309.171875 216.539062 C 323.296875 148.304688 279.292969 81.324219 211.058594 67.199219 Z M 211.058594 67.199219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogojasne);
export default __webpack_public_path__ + "static/media/logojasne.ae80d1aeb4f6cb5a40c279a5473c3823.svg";
export { ForwardRef as ReactComponent };